import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicBarComponent } from './bar/basic-bar/basic-bar.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { ENgxPrintModule } from 'e-ngx-print';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { FormsModule } from '@angular/forms';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BcacSelectModule } from 'bcac-lib/base-component/currency/bcac-select';
import { BcacSelectGroupModule } from 'bcac-lib/base-component/currency/bcac-select-group';
import { ToolboxComponent } from './toolbox/toolbox.component';
import { HorizontalBarComponent } from './bar/horizontal-bar/horizontal-bar.component';
import { NegativeBarComponent } from './bar/nagetive-bar/negative-bar.component';
import { StackColumnComponent } from './bar/stack-column/stack-column.component';
import { PyramidBarComponent } from './bar/pyramid-bar/pyramid-bar.component';
import { BasicLineComponent } from './line/basic-line/basic-line.component';
import { BigDataLineChartComponent } from './line/big-data-line-chart/big-data-line-chart.component';
import { MultiLineChartComponent } from './line/multi-line-chart/multi-line-chart.component';
import { BasicPieComponent } from './pie/basic-pie/basic-pie.component';
import { LegendPieComponent } from './pie/legend-pie/legend-pie.component';
import { RosePieComponent } from './pie/rose-pie/rose-pie.component';
import { BasicBarLineComponent } from './combiination/basic-bar-line/basic-bar-line.component';
import { NoiseAnalysisLineComponent } from './line/noise-analysis-line/noise-analysis-line.component';
import { NoiseAnalysisToolboxComponent } from './toolbox/noise-analysis-toolbox/noise-analysis-toolbox.component';
import { TimelineMapComponent } from './map/timeline-map/timeline-map.component';
import { ScatterMapComponent } from './map/scatter-map/scatter-map.component';
import { WebGLMapComponent } from './map/web-gl-map/web-gl-map.component';
import { NoiseDropboxLineComponent } from './line/noise-dropbox-line/noise-dropbox-line.component';
import { BcacMultipleSelectModule } from 'bcac-lib/base-component/currency/bcac-multiple-select';
import { BcacIconModule } from 'bcac-lib/base-component/currency/bcac-icon';
import { DistrictMapComponent } from './map/district-map/district-map.component';
import { TransformNullValuePipe } from './map/web-gl-map/transform-null-value.pipe';
import { ChartMenuComponent } from './chart-menu/chart-menu.component';
import { NoiseEventWaveComponent } from './line/noise-event-wave/noise-event-wave.component';
import { DoubleYaxisBarComponent } from './bar/double-yaxis-bar/double-yaxis-bar.component';
import { RingPieComponent } from './pie/ring-pie/ring-pie.component';
import { BasicBoxPlotComponent } from './box-plot/basic-box-plot/basic-box-plot.component';
import { EventWaveComponent } from './line/event-wave/event-wave.component';
import { NoiseCustomLineComponent } from './line/noise-custom-line/noise-custom-line.component';
import { BcacSourceGroupModule } from 'bcac-lib/base-component/currency/bcac-source-group';
import { DrillDownMapComponent } from './map/drill-down-map/drill-down-map.component';
import { BoxPlotLineComponent } from './box-plot/box-plot-line/box-plot-line.component';
import { CompareChartComponent } from './custom/compare-chart/compare-chart.component';
import { NoiseAnaliysisBlockComponent } from './line/noise-analiysis-block/noise-analiysis-block.component';
import { MultiDimensionBarComponent } from './bar/multi-dimension-bar/multi-dimension-bar.component';
import { BaseGaugeComponent } from './gauge/base-gauge/base-gauge.component';
import { DoubleYaxisVisualmapLineComponent } from './line/double-yaxis-visualmap-line/double-yaxis-visualmap-line.component';
import { IndexGaugeComponent } from './gauge/index-gauge/index-gauge.component';
import { IndexPieComponent } from './pie/index-pie/index-pie.component';
import { DoubleRingPieComponent } from './pie/double-ring-pie/double-ring-pie.component';
import { DoubleYaxisLineComponent } from './line/double-yaxis-line/double-yaxis-line.component';
import { BasicScatterComponent } from './scatter/basic-scatter/basic-scatter.component';
import { ProgressPieComponent } from './pie/progress-pie/progress-pie.component';
import { ScatterLineComponent } from './combiination/scatter-line/scatter-line.component';

@NgModule({
  declarations: [
    BasicBarComponent, ToolboxComponent, HorizontalBarComponent,
    NegativeBarComponent, StackColumnComponent, PyramidBarComponent,
    BasicLineComponent,
    BigDataLineChartComponent,
    MultiLineChartComponent,
    BasicPieComponent,
    LegendPieComponent,
    RosePieComponent,
    BasicBarLineComponent,
    NoiseAnalysisLineComponent,
    NoiseAnalysisToolboxComponent,
    TimelineMapComponent,
    ScatterMapComponent,
    WebGLMapComponent,
    NoiseDropboxLineComponent,
    DistrictMapComponent,
    TransformNullValuePipe,
    ChartMenuComponent,
    NoiseEventWaveComponent,
    DoubleYaxisBarComponent,
    RingPieComponent,
    BasicBoxPlotComponent,
    EventWaveComponent,
    NoiseCustomLineComponent,
    DrillDownMapComponent,
    BoxPlotLineComponent,
    CompareChartComponent,
    NoiseAnaliysisBlockComponent,
    MultiDimensionBarComponent,
    BaseGaugeComponent,
    DoubleYaxisVisualmapLineComponent,
    IndexGaugeComponent,
    IndexPieComponent,
    DoubleRingPieComponent,
    DoubleYaxisLineComponent,
    BasicScatterComponent,
    ProgressPieComponent,
    ScatterLineComponent,
  ],
  imports: [
    CommonModule,
    NgZorroAntdModule,
    NgxEchartsModule,
    ENgxPrintModule,
    FormsModule,
    BcacSelectModule,
    BcacMultipleSelectModule,
    NzToolTipModule,
    BcacSelectGroupModule,
    BcacIconModule,
    BcacSourceGroupModule
  ],
  providers: [],
  exports: [
    BasicBarComponent, HorizontalBarComponent, NegativeBarComponent,
    StackColumnComponent,
    PyramidBarComponent, BasicLineComponent,
    BigDataLineChartComponent,
    MultiLineChartComponent,
    BasicPieComponent, LegendPieComponent, RosePieComponent,
    BasicBarLineComponent,
    NoiseAnalysisLineComponent,
    TimelineMapComponent,
    ScatterMapComponent,
    WebGLMapComponent,
    NoiseDropboxLineComponent,
    DistrictMapComponent,
    NoiseEventWaveComponent,
    DoubleYaxisBarComponent,
    EventWaveComponent,
    NoiseCustomLineComponent,
    RingPieComponent,
    BasicBoxPlotComponent,
    EventWaveComponent,
    DrillDownMapComponent,
    BoxPlotLineComponent,
    NoiseAnaliysisBlockComponent,
    CompareChartComponent,
    MultiDimensionBarComponent,
    BaseGaugeComponent,
    DoubleYaxisVisualmapLineComponent,
    IndexGaugeComponent,
    IndexPieComponent,
    DoubleRingPieComponent,
    DoubleYaxisLineComponent,
    BasicScatterComponent,
    ProgressPieComponent,
    ScatterLineComponent
  ]

})
export class ChartModule { }
